import React from 'react';
import './App.css';
import { Router, Switch, Route, Redirect } from "react-router";
import { createBrowserHistory } from 'history';
import { UpdaterPage } from './pages/Updater';
import { SettingsPage } from './pages/Setting';
import { ComponentPage } from './pages/Components';
import { PluginPage } from './pages/Plugins';
import { MainPage } from './pages/Main';

function App() {
  const history = createBrowserHistory();
  return (
    <div className="App">
            <Router history={history}>
                <Switch>
                    <Route path="/updater" component={() => <UpdaterPage></UpdaterPage>}/>
                    <Route path="/settings" component={() => <SettingsPage></SettingsPage>}/>
                    <Route path="/services" component={() => <ComponentPage></ComponentPage>}/>
                    <Route path="/plugins" component={() => <PluginPage></PluginPage>}/>
                    <Route path="/main" component={() => <MainPage></MainPage>}/>
                    <Redirect from="/" to="/main"/>
                </Switch>
            </Router>
    </div>
  );
}

export default App;
